<template>
  <!-- Select de transporte (PAC / SEDEX / RETIRA), como no sistema legado.
       As opções são resolvidas contra sls_transportadora do tenant pelo nome
       abreviado; se nenhuma existir, o select não é exibido. -->
  <b-form-group
    v-if="options.length > 1"
    label="Transporte"
    label-for="selectTransporte"
    :state="state"
    :invalid-feedback="invalidFeedback"
  >
    <b-form-select
      id="selectTransporte"
      ref="selectEl"
      :value="value"
      :options="options"
      :disabled="disabled"
      :state="state"
      @change="$emit('input', $event)"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormSelect } from 'bootstrap-vue';
import SlsTransportadoraClient from '@/api/Cadastros/info-organizacionais/sls-transportadora.client';

// Mapa nome abreviado (sls_transportadora) → rótulo exibido ao usuário.
const OPCOES_TRANSPORTE = [
  { abrev: 'CORREIO', label: 'CORREIO - PAC' },
  { abrev: 'SEDEX', label: 'CORREIO - SEDEX' },
  { abrev: 'RETIRA', label: 'RETIRA' },
];

export default {
  name: 'SelectTransporte',
  components: { BFormGroup, BFormSelect },
  props: {
    value: { type: [String, Number], default: null },
    disabled: { type: Boolean, default: false },
    // state: null (neutro), true (válido), false (inválido — borda vermelha)
    state: { type: Boolean, default: null },
    invalidFeedback: { type: String, default: 'Selecione o tipo de transporte.' },
  },
  data() {
    return {
      options: [{ value: null, text: 'Selecione' }],
    };
  },
  methods: {
    /** Foca o select de transporte — pode ser chamado pelo componente pai. */
    focusSelect() {
      this.$nextTick(() => {
        const el = this.$refs.selectEl;
        if (el && el.$el) {
          el.$el.focus();
        } else if (el) {
          el.focus();
        }
      });
    },
  },
  async mounted() {
    try {
      const client = new SlsTransportadoraClient();
      // perPage alto: a rota é paginada (default ~20) e CORREIO/RETIRA ficam
      // fora da 1ª página; precisamos da lista completa p/ resolver os 3 ids.
      const { data: resp } = await client.index({ perPage: 5000 });
      const lista = Array.isArray(resp) ? resp : (resp?.data?.data || resp?.data || resp?.rows || []);
      const porAbrev = {};
      (lista || []).forEach((t) => {
        const ab = String(t.transportadoranomeabrev || '').trim().toUpperCase();
        if (!porAbrev[ab]) porAbrev[ab] = t;
      });
      OPCOES_TRANSPORTE.forEach(({ abrev, label }) => {
        const t = porAbrev[abrev];
        if (t && t.transportadoraid) {
          this.options.push({ value: String(t.transportadoraid), text: label });
        }
      });
    } catch (e) {
      // Sem lista de transportadoras → mantém só "Selecione" e o select some.
      console.error('[SelectTransporte] erro ao carregar transportadoras', e);
    }
  },
};
</script>
